import {createStandardAction} from "typesafe-actions";
import {IDialogActionPayload, IDialog} from "./types";

export const showDialog = createStandardAction('@dialogs/SHOW_DIALOG')<IDialog>();
export const actuallyShowDialog = createStandardAction('@dialogs/ACTUALLY_SHOW_DIALOG')<IDialog>();
export const closeDialog = createStandardAction('@dialogs/CLOSE_DIALOG')<IDialogActionPayload | void>();